import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Footer from "../Footer/footer";
import { useAuth, User } from "../../AuthContext/AuthContext";
import { ModulosEnum } from "../../shared/enum/modulos.enum";
import Swal from "sweetalert2";
import authService from "../../services/AuthService";

const rotaParaModuloMap: Record<string, ModulosEnum> = {
  "/consulta-rapida": ModulosEnum.CONSULTA_RAPIDA,
  "/cadastros-gerais": ModulosEnum.CADASTROS_GERAIS,

  "/list-users": ModulosEnum.USUARIOS,
  "/remessas": ModulosEnum.REMESSA_RETORNO,
  "/lotacao": ModulosEnum.LOTACOES,
  "/local-pagamento": ModulosEnum.LOCAL_PAGAMENTO,
  "/instrucao-bancaria": ModulosEnum.INSTRUCOES_BANCARIAS,
  "/forma-pagamento": ModulosEnum.FORMA_PAGAMENTO,
  "/list-contribuinte": ModulosEnum.CONTRIBUINTE,
  "/contribuinte": ModulosEnum.DETALHES_CONTRIBUINTE,
  "/caixa": ModulosEnum.CAIXA,
  "/relatorios-gerenciais": ModulosEnum.RELATORIOS_GERENCIAIS,
  "/reajuste-parcelas": ModulosEnum.REAJUSTE_VALORES_FINANCEIROS,
};

const ProtectedLayout = () => {
  const [sizeWidth, setSizeWidth] = useState(window.innerWidth);
  const [sizeHeight, setSizeHeight] = useState(window.innerHeight);
  const [navSelected, setNavSelected] = useState<string>("Contribuintes");
  const [verificandoAcesso, setVerificandoAcesso] = useState(true);

  const { logout, token, user, setUser, setToken } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const updateSize = () => {
    setSizeWidth(window.innerWidth);
    setSizeHeight(window.innerHeight);
  };
  const loginByToken = async (oldToken: string) => {
    await authService
      .loginByToken(oldToken)
      .then((response) => {
        const { accessToken, user } = response;
        // Garante que o ID seja um número válido
        const userId =
          typeof user.id === "string" ? parseInt(user.id, 10) : Number(user.id);

        if (isNaN(userId) || userId <= 0) {
          console.error("Invalid user ID:", user.id);
          throw new Error("ID de usuário inválido");
        }
        const userToStore = {
          id: userId,
          name: user.name,
          email: user.email,
          permission: user.permission,
          isActive: user.isActive ?? true,
        };
        const userToAuth = {
          id: userId,
          name: user.name,
          email: user.email,
          permission: user.permission,
          isActive: user.isActive ?? true,
          controleAcesso: user.controleAcesso,
        };

        sessionStorage.setItem("authToken", accessToken);
        sessionStorage.setItem("user", JSON.stringify(userToStore));

        // Atualiza contexto de autenticação
        setToken(accessToken);
        setUser(userToAuth);
      })
      .catch((error) => {
        console.error("Erro ao fazer login:", error);
        logout();
      });
  };

  useEffect(() => {
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    setVerificandoAcesso(true);
    const currentPath = location.pathname.toLowerCase();
    const modulo = rotaParaModuloMap[currentPath];
    if (modulo && user?.controleAcesso && token) {
      let temAcesso = user.controleAcesso.some(
        (acesso) => acesso.modulos?.nome === modulo
      );
      //Caso seja a tela de detalhes do contribuinte, verificar se ele tem acesso a alguma aba
      if (modulo === ModulosEnum.DETALHES_CONTRIBUINTE) {
        temAcesso = user.controleAcesso.some(
          (acesso) =>
            acesso.modulos?.nome === ModulosEnum.DADOS_PESSOAIS ||
            acesso.modulos?.nome === ModulosEnum.MOVIMENTACOES ||
            acesso.modulos?.nome === ModulosEnum.DEPENDENTES ||
            acesso.modulos?.nome === ModulosEnum.DADOS_FINANCEIROS ||
            acesso.modulos?.nome === ModulosEnum.FICHA_FINANCEIRA
        );
      }

      //Caso seja a tela de remessar ou retornor, verificar se ele tem acesso a algum dos dois
      if (modulo === ModulosEnum.REMESSA_RETORNO) {
        temAcesso = user.controleAcesso.some(
          (acesso) =>
            acesso.modulos?.nome === ModulosEnum.REMESSAS ||
            acesso.modulos?.nome === ModulosEnum.RETORNOS
        );
      }

      if (modulo === ModulosEnum.CADASTROS_GERAIS) {
        temAcesso = user.controleAcesso.some(
          (acesso) =>
            acesso.modulos?.nome === ModulosEnum.LOTACOES ||
            acesso.modulos?.nome === ModulosEnum.LOCAL_PAGAMENTO ||
            acesso.modulos?.nome === ModulosEnum.INSTRUCOES_BANCARIAS ||
            acesso.modulos?.nome === ModulosEnum.FORMA_PAGAMENTO
        );
      }

      if (!temAcesso) {
        // Se quiser apenas redirecionar:
        navigate("/acesso-negado");
        // Ou se quiser deslogar:
        // logout();
        // navigate("/");
      }
      setVerificandoAcesso(false); // Libera a renderização
    } else {
      if (!user) {
        const token = sessionStorage.getItem("authToken");
        if (token) {
          loginByToken(token);
        } else {
          if (!modulo) {
            Swal.fire({
              title: "Sessão expirada!",
              text: "Sua sessão expirou. Por favor, faça login novamente.",
              icon: "warning",
              confirmButtonText: "OK",
              allowOutsideClick: false,
            }).then(() => {
              logout();
            });
          }
        }
      }
    }
    setVerificandoAcesso(false);
  }, [location.pathname, user]);

  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          display: "flex",
          marginTop: "90px",
          minWidth: sizeWidth,
          minHeight: sizeHeight,
        }}
      >
        <Navbar />
        <div
          className="main-content"
          style={{
            flex: 1,
            marginLeft: "250px",
            margin: 0,
          }}
        >
          {!verificandoAcesso && <Outlet />}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProtectedLayout;
